// src/pages/Orders/Orders.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ordersAPI } from '../../api/orders.js';
import { Breadcrumbs } from '../../components/common/Breadcrumbs/Breadcrumbs.jsx';
import { Loader } from '../../components/ui/Loader/Loader.jsx';
import { formatDate, formatPrice } from '../../utils/formatters.js';
import { ORDER_STATUS_LABELS } from '../../utils/constants.js';

export const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadOrders();
  }, []);

  const loadOrders = async () => {
    setIsLoading(true);
    try {
      const response = await ordersAPI.getMy({ limit: 50 });
      setOrders(response.data.data || []);
    } catch (error) {
      console.error('Error loading orders:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const breadcrumbs = [{ label: 'Мои заказы', path: '/orders' }];

  if (isLoading) {
    return <Loader text="Загрузка заказов..." />;
  }

  return (
    <div style={{ backgroundColor: 'rgb(var(--c-bg))', minHeight: '100vh', paddingBottom: '40px' }}>
      <div className="container" style={{ paddingTop: '24px' }}>
        <Breadcrumbs items={breadcrumbs} />

        <h1 style={{
          fontSize: '32px',
          fontWeight: 700,
          color: 'rgb(var(--c-text))',
          marginTop: '24px',
          marginBottom: '32px',
        }}>
          Мои заказы
        </h1>

        {orders.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '60px 0',
            backgroundColor: 'rgb(var(--c-surface))',
            borderRadius: '20px',
            border: '1px solid rgb(var(--c-border))',
          }}>
            <p style={{ fontSize: '18px', color: 'rgb(var(--c-text-secondary))' }}>У вас пока нет заказов</p>
            <Link to="/catalog">
              <button style={{
                marginTop: '16px',
                padding: '12px 24px',
                backgroundColor: 'rgb(var(--c-accent))',
                color: 'rgb(var(--c-on-accent))',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '16px',
              }}>
                Перейти в каталог
              </button>
            </Link>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {orders.map((order) => (
              <Link
                key={order.id}
                to={`/orders/${order.id}`}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div style={{
                  backgroundColor: 'rgb(var(--c-surface))',
                  border: '1px solid rgb(var(--c-border))',
                  borderRadius: '16px',
                  padding: '20px 24px',
                  transition: 'box-shadow 0.2s',
                }}
                onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.06)'}
                onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
                >
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '12px',
                  }}>
                    <div>
                      <div style={{
                        fontSize: '16px',
                        fontWeight: 600,
                        color: 'rgb(var(--c-text))',
                      }}>
                        Заказ #{order.order_number}
                      </div>
                      <div style={{
                        fontSize: '14px',
                        color: 'rgb(var(--c-text-secondary))',
                        marginTop: '4px',
                      }}>
                        {formatDate(order.createdAt)}
                      </div>
                    </div>

                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '16px',
                    }}>
                      <span style={{
                        padding: '4px 12px',
                        borderRadius: '100px',
                        fontSize: '12px',
                        fontWeight: 500,
                        backgroundColor: order.status === 'completed' ? '#28A745' :
                                      order.status === 'cancelled' ? '#DC3545' :
                                      '#FFC107',
                        color: 'rgb(var(--c-on-accent))',
                      }}>
                        {ORDER_STATUS_LABELS[order.status] || order.status}
                      </span>
                      <span style={{
                        fontSize: '18px',
                        fontWeight: 700,
                        color: 'rgb(var(--c-accent))',
                      }}>
                        {formatPrice(order.total)}
                      </span>
                    </div>
                  </div>

                  <div style={{
                    marginTop: '12px',
                    display: 'flex',
                    gap: '8px',
                    flexWrap: 'wrap',
                  }}>
                    {order.OrderItems?.slice(0, 3).map((item) => (
                      <span
                        key={item.id}
                        style={{
                          fontSize: '13px',
                          color: 'rgb(var(--c-text-secondary))',
                          backgroundColor: 'rgb(var(--c-surface-2))',
                          padding: '2px 8px',
                          borderRadius: '4px',
                        }}
                      >
                        {item.product_name} × {item.quantity}
                      </span>
                    ))}
                    {order.OrderItems?.length > 3 && (
                      <span style={{ fontSize: '13px', color: 'rgb(var(--c-text-secondary))' }}>
                        +{order.OrderItems.length - 3} еще
                      </span>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};